import {
  TCountEventsRequest,
  TCensusSizeResponse,
  TGetVaultResponse,
  TRemoveVoterRequest,
  TDecodeVoterlinkRequest,
  TDecodeVoterlinkResponse,
  TGetVaultRequest,
  TCreateElectionResponse,
  TCensusFileRequest,
  TStoreVaultResponse,
  TAddVoterRequest,
  TVerifyVoteResponse,
  TLoginRequest,
  TInsertVoterResponse,
  TUpdateVoterRequest,
  TCensusResponse,
  TGetParticipationRequest,
  TSendMessageRequest,
  TVoterinfoResponse,
  TVoteResponse,
  TUpdateBasicFieldsRequest,
  TRemoveMessageRequest,
  TUploadCensusRequest,
  TInsertElementResponse,
  TCountEventsResponse,
  TElectionId,
  TElectionsCountResponse,
  TScheduleResponse,
  TGenerateEncriptedPublicResultsLinkResponse,
  TElectionListResponse,
  TCensusFileResponse,
  TGetEventsRequest,
  TVerifyVoteRequest,
  TElectionResponseWithOwner,
  TGenerateEncriptedVoteLinksResponse,
  TGenerateEncriptedVoteLinksRequest,
  TGetEventsResponse,
  TRemoveQuestionRequest,
  TIsTokenValidResponse,
  TDuplicateElectionRequest,
  TAddMessageRequest,
  TElectionListRequest,
  TAddQuestionRequest,
  THasVotedResponse,
  TElectionsCountRequest,
  TExtendElectionRequest,
  TRemoveCandidateRequest,
  TVotesListResponse,
  TCensusRequest,
  TVoteRequest,
  TLoginResponse,
  TResponse,
  TElectionRenderInfoResponse,
  TAddCandidateRequest,
  TPatchVoterRequest,
  TUpdateVoterPropsFromLinkRequest,
  TDecryptVotesRequest,
  TIsTokenValidRequest,
  TStoreVaultRequest,
  TElectionResponse,
  TGetParticipationResponse,
  TResponseWithWarnings,
  TElectionFindByIdRequest,
  TUpdatePropsRequest,
  TCreateElectionRequest,
} from "./generated_types"



function getLanguage(): string {
  const pathSegments = window.location.pathname.split('/').filter(Boolean);;
  const langCode = pathSegments[0];

  return langCode
}

// Set token
// export function setToken(token: string) {
//   localStorage.setItem("token", token)
// }

// Get token
// export function getToken(): string|null {
//   return localStorage.getItem("token")
// }

const baseUrl = (window as any).APP_CONFIG?.BASE_URL || "https://localhost:8080"

export async function authFetch(url: URL | RequestInfo, options?: RequestInit): Promise<Response> {
//   const token = getToken()
  return fetch(url, {
    ...options,
    headers: {
//       Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...options?.headers
    },
  })
}

export async function authMultipartFetch(url: URL | RequestInfo, options?: RequestInit): Promise<Response> {
//   const token = getToken()
  return fetch(url, {
    ...options,
    headers: {
//       Authorization: `Bearer ${token}`,
      ...options?.headers
    },
  })
}       

export async function loginRequest(payload: TLoginRequest): Promise<TLoginResponse> {
  const resp = await fetch(`${window.location.origin}/api/v1/election/login`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TLoginResponse = await resp.json()
  return data
}


export async function listRequest(payload: TElectionListRequest): Promise<TElectionListResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/list`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TElectionListResponse = await resp.json()
  return data
}


export async function countRequest(payload: TElectionsCountRequest): Promise<TElectionsCountResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/count`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TElectionsCountResponse = await resp.json()
  return data
}


export async function findbyidRequest(payload: TElectionFindByIdRequest): Promise<TElectionResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/findbyid`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TElectionResponse = await resp.json()
  return data
}


export async function findbyidwithownerRequest(payload: TElectionFindByIdRequest): Promise<TElectionResponseWithOwner> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/findbyidwithowner`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TElectionResponseWithOwner = await resp.json()
  return data
}


export async function createRequest(payload: TCreateElectionRequest): Promise<TCreateElectionResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/create`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TCreateElectionResponse = await resp.json()
  return data
}


export async function duplicateRequest(payload: TDuplicateElectionRequest): Promise<TCreateElectionResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/duplicate`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TCreateElectionResponse = await resp.json()
  return data
}


export async function updatebasicfieldsRequest(payload: TUpdateBasicFieldsRequest): Promise<TResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/updatebasicfields`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TResponse = await resp.json()
  return data
}


export async function extendelectionRequest(payload: TExtendElectionRequest): Promise<TResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/extendelection`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TResponse = await resp.json()
  return data
}


export async function updateoraddmessageRequest(payload: TAddMessageRequest): Promise<TInsertElementResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/updateoraddmessage`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TInsertElementResponse = await resp.json()
  return data
}


export async function sendmessageRequest(payload: TSendMessageRequest): Promise<TResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/sendmessage`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TResponse = await resp.json()
  return data
}


export async function removemessageRequest(payload: TRemoveMessageRequest): Promise<TElectionResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/removemessage`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TElectionResponse = await resp.json()
  return data
}


export async function updatepropsRequest(payload: TUpdatePropsRequest): Promise<TElectionResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/updateprops`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TElectionResponse = await resp.json()
  return data
}


export async function scheduleRequest(payload: TElectionId): Promise<TScheduleResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/schedule`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TScheduleResponse = await resp.json()
  return data
}


export async function removeRequest(payload: TElectionId): Promise<TResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/remove`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TResponse = await resp.json()
  return data
}


export async function pauseRequest(payload: TElectionId): Promise<TResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/pause`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TResponse = await resp.json()
  return data
}


export async function censusRequest(payload: TCensusRequest): Promise<TCensusResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/census`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TCensusResponse = await resp.json()
  return data
}


export async function censussizeRequest(payload: TElectionId): Promise<TCensusSizeResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/censussize`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TCensusSizeResponse = await resp.json()
  return data
}


export async function addvoterRequest(payload: TAddVoterRequest): Promise<TInsertVoterResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/addvoter`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TInsertVoterResponse = await resp.json()
  return data
}


export async function uploadcensusRequest(payload: TUploadCensusRequest): Promise<TResponseWithWarnings> {
  const formData = new FormData()
  formData.append("election", String(payload.election))
  formData.append("census", payload.census)
  const resp = await authMultipartFetch(`${window.location.origin}/api/v1/election/uploadcensus`, { method: "POST", body: formData })
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TResponseWithWarnings = await resp.json()
  return data
}


export async function downloadcensusRequest(payload: TCensusFileRequest): Promise<Blob> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/downloadcensus`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data = await resp.blob()
  return data
}


export async function updatevoterRequest(payload: TUpdateVoterRequest): Promise<TResponseWithWarnings> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/updatevoter`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TResponseWithWarnings = await resp.json()
  return data
}


export async function patchvoterRequest(payload: TPatchVoterRequest): Promise<TResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/patchvoter`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TResponse = await resp.json()
  return data
}


export async function updatevoterpropsfromlinkRequest(payload: TUpdateVoterPropsFromLinkRequest): Promise<TResponseWithWarnings> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/updatevoterpropsfromlink`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TResponseWithWarnings = await resp.json()
  return data
}


export async function removevoterRequest(payload: TRemoveVoterRequest): Promise<TResponseWithWarnings> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/removevoter`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TResponseWithWarnings = await resp.json()
  return data
}


export async function updateoraddquestionRequest(payload: TAddQuestionRequest): Promise<TInsertElementResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/updateoraddquestion`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TInsertElementResponse = await resp.json()
  return data
}


export async function removequestionRequest(payload: TRemoveQuestionRequest): Promise<TElectionResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/removequestion`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TElectionResponse = await resp.json()
  return data
}


export async function updateoraddcandidateRequest(payload: TAddCandidateRequest): Promise<TInsertElementResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/updateoraddcandidate`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TInsertElementResponse = await resp.json()
  return data
}


export async function removecandidateRequest(payload: TRemoveCandidateRequest): Promise<TElectionResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/removecandidate`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TElectionResponse = await resp.json()
  return data
}


export async function decryptvotesRequest(payload: TDecryptVotesRequest): Promise<TVotesListResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/decryptvotes`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TVotesListResponse = await resp.json()
  return data
}


export async function voteRequest(payload: TVoteRequest): Promise<TVoteResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/vote`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TVoteResponse = await resp.json()
  return data
}


export async function istokenvalidRequest(payload: TIsTokenValidRequest): Promise<TIsTokenValidResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/istokenvalid`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TIsTokenValidResponse = await resp.json()
  return data
}


export async function getvotelinksRequest(payload: TElectionId): Promise<TGenerateEncriptedVoteLinksResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/getvotelinks`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TGenerateEncriptedVoteLinksResponse = await resp.json()
  return data
}


export async function generatevotelinksRequest(payload: TGenerateEncriptedVoteLinksRequest): Promise<TResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/generatevotelinks`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TResponse = await resp.json()
  return data
}


export async function generatepublicresultslinkRequest(payload: TElectionId): Promise<TGenerateEncriptedPublicResultsLinkResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/generatepublicresultslink`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TGenerateEncriptedPublicResultsLinkResponse = await resp.json()
  return data
}


export async function decodevoterlinkRequest(payload: TDecodeVoterlinkRequest): Promise<TDecodeVoterlinkResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/decodevoterlink`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TDecodeVoterlinkResponse = await resp.json()
  return data
}


export async function hasvotedRequest(payload: TDecodeVoterlinkRequest): Promise<THasVotedResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/hasvoted`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: THasVotedResponse = await resp.json()
  return data
}


export async function verifyvoteRequest(payload: TVerifyVoteRequest): Promise<TVerifyVoteResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/verifyvote`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TVerifyVoteResponse = await resp.json()
  return data
}


export async function electionrenderinfoRequest(payload: TDecodeVoterlinkRequest): Promise<TElectionRenderInfoResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/electionrenderinfo`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TElectionRenderInfoResponse = await resp.json()
  return data
}


export async function voterinfoRequest(payload: TDecodeVoterlinkRequest): Promise<TVoterinfoResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/voterinfo`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TVoterinfoResponse = await resp.json()
  return data
}


export async function storevaultRequest(payload: TStoreVaultRequest): Promise<TStoreVaultResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/storevault`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TStoreVaultResponse = await resp.json()
  return data
}


export async function getvaultRequest(payload: TGetVaultRequest): Promise<TGetVaultResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/getvault`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TGetVaultResponse = await resp.json()
  return data
}


export async function geteventsRequest(payload: TGetEventsRequest): Promise<TGetEventsResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/getevents`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TGetEventsResponse = await resp.json()
  return data
}


export async function counteventsRequest(payload: TCountEventsRequest): Promise<TCountEventsResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/countevents`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TCountEventsResponse = await resp.json()
  return data
}


export async function participationRequest(payload: TGetParticipationRequest): Promise<TGetParticipationResponse> {
  const resp = await authFetch(`${window.location.origin}/api/v1/election/participation`, {method: "POST", body: JSON.stringify(payload)})
  if (resp.status === 401) {
    await fetch(`${window.location.origin}/logout`, {method: "POST"}).then(() => {window.location.pathname = "/"+getLanguage()+"/login"})
  }
  const data: TGetParticipationResponse = await resp.json()
  return data
}


